<template>
  <div class="ele-body">
    <el-card shadow="never"  v-loading="loading" header="网站专题" body-style="padding-bottom:0;" style="margin-bottom: 15px;">
      <!-- 搜索表单 -->
      <el-form :model="where" label-width="77px" class="ele-form-search"
               @keyup.enter.native="query()" @submit.native.prevent>
        <el-row :gutter="15">
          <el-col :md="6" :sm="12">
            <el-form-item label="专题标题:">
              <el-input v-model="where.title" placeholder="请输入专题标题" clearable/>
            </el-form-item>
          </el-col>
          <el-col :md="9" :sm="12">
            <div class="ele-form-actions">
              <el-button type="primary" @click="query" icon="el-icon-search" class="ele-btn-icon">查询
              </el-button>
              <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon">添加</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-row :gutter="15">
      <el-col v-for="(item,index) in data" :key="index" :md="6" :sm="8" :xs="12">
        <el-card class="project-list-item" shadow="hover">
          <div class="project-list-cover">
            <img :src="item.cover" alt=""/>
          </div>
          <div class="project-list-body">
            <h6 class="ele-elip"><b>{{ item.title }}</b></h6>
            <div class="project-list-desc">{{ item.intro }}</div>
            <div class="project-list-time">
              <div class="project-list-time-text">{{ item.time }}</div>
              <ele-avatar-list :data="item.users" size="22px"/>
            </div>
          </div>
          <el-divider/>
          <div class="application-list-footer">
            <div class="application-list-tool">
              <el-tooltip content="下载素材" placement="top">
                <i class="el-icon-download ele-text-secondary"/>
              </el-tooltip>
            </div>
            <el-divider direction="vertical" class="line-color-light"/>
            <div class="application-list-tool">
              <el-tooltip content="编辑" placement="top">
                <i class="el-icon-edit ele-text-secondary" @click="edit(item)"/>
              </el-tooltip>
            </div>
            <el-divider direction="vertical" class="line-color-light"/>
            <div class="application-list-tool">
              <el-tooltip content="分享" placement="top">
                <i class="el-icon-share ele-text-secondary"/>
              </el-tooltip>
            </div>
            <el-divider direction="vertical" class="line-color-light"/>
            <div class="application-list-tool">
              <el-dropdown placement="bottom">
                <i class="el-icon-more ele-text-secondary"/>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>删除</el-dropdown-item>
                  <el-dropdown-item>详情</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-pagination :current-page="page.page" :page-size="page.limit" :total="count" :background="true"
                   @size-change="d=>(page.limit=d)&&query()" @current-change="d=>(page.page=d)&&query()"
                   layout="prev, pager, next" :pager-count="5" class="ele-pagination-circle"/>
  
  <!-- 编辑数据表 -->
    <website-edit 
        v-if="showEdit"
        @returnBack="showEdit=false"
        :visible="showEdit"
        :projectId="projectId"
        @reload="reload()"
    ></website-edit >

  </div>
</template>

<script>
import WebsiteEdit from './website-edit';
export default {
  name: "WebsiteProject",
  components: {WebsiteEdit},
  data() {
    return {
      where: {},
      showEdit: false,
      projectId: 0,
      loading: false,               // 列表加载状态
      page: {page: 1, limit: 8},    // 分页参数
      count: 0,                    // 数据总数
      data: []
    }
  },
  mounted() {
    // 获取专题列表
    this.query();
  },
  methods: {
    query() {
      this.loading = true;
      this.$http.get('/webproject/index', {params: {
        page: this.page.page,
        limit: this.page.limit,
        title: this.where.title,
      }}).then(res => {
        if (res.data.code === 0) {
          this.loading = false;
          this.data = res.data.data;
          this.count = res.data.count;
        } else {
          this.loading = false;
          this.$message.error(res.data.msg);
        }
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      });
    },
    /**
     * 显示编辑
     */
    edit(item) {
      console.log(item)
      this.projectId = item.id;
      this.showEdit = true;
    },
    // 回调并刷新
    reload(){
      this.showEdit = false;
      this.query();
    },
  }
}
</script>

<style scoped>
.project-list-item {
  margin-bottom: 15px;
}

.project-list-item >>> .el-card__body {
  padding: 0;
}

.project-list-cover > img {
  width: 100%;
  height: auto;
  display: block;
  object-fit: cover;
}

.project-list-body {
  padding: 15px;
}

.project-list-desc {
  height: 44px;
  line-height: 22px;
  margin-top: 6px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

.project-list-time {
  display: flex;
  margin-top: 6px;
  align-items: center;
}

.project-list-time-text {
  flex: 1;
}

.application-list-footer {
  display: flex;
  padding: 8px 0;
}

.application-list-tool {
  flex: 1;
  text-align: center;
}

.application-list-tool >>> i {
  font-size: 18px;
  line-height: 36px;
  cursor: pointer;
}

.application-list-footer >>> .el-divider--vertical {
  height: 36px;
}
</style>